<div class="section border-bottom p-3">
    <div class="title d-flex">
        <div class="flex-1">{{ handler?.title }}</div>
        @if (cellset && currentValue) {
            <div>
                {{ currentValue }}
                @if (diffValue !== "0") {
                    <span [class]="'text-' + (diffIcon.includes('up') ? 'success' : 'danger')"> <kui-icon [name]="diffIcon"></kui-icon> {{ diffValue }} </span>
                }
            </div>
        }
    </div>
    <div class="chart flex-1 d-flex mt-3 p-1">
        @if (!cellset && !errorMessage) {
            <div class="loader d-flex flex-stretch justify-content-center align-items-center">
                <kui-loader> </kui-loader>
            </div>
        }

        <kui-alert-panel [size]="3" [message]="errorMessage"></kui-alert-panel>

        @if (cellset && !errorMessage) {
            <key-analytics-chart [type]="chartType" [cellset]="cellset" [settings]="settings" [size]="'large'" (onLoad)="onChartLoaded($event)"></key-analytics-chart>
        }
    </div>
</div>
